import { lazy } from "react"

export const AuthorizationCallBackSuccess = lazy(() => import("./AuthorizationCallBackSuccess"))
